import React from 'react';

import UserInput from "../UI/ReactUserInput";
import UserInputTextarea from "../UI/ReactUserInputTextarea";
import DropdownSchoolYear from "../UI/ReactDropdownSchoolYear";
import DropdownYesNo from "../UI/ReactDropdownYesNo";
import DropdownMetNotMet from "../UI/ReactDropdownMetNotMet";
import DropdownAttitude from "../UI/ReactDropdownAttitude";
import DropdownYesNoUnknown from "../UI/ReactDropdownYesNoUnknown";


export default class MultiPageForm extends React.Component
{
	constructor ( props )
	{
		super(props) ;

		this.state =
		{
			displayErrors: false
		} ;

		this.state.prevButtonRequired = this.props.prevButtonRequired == true ? true : false ;

		if ( this.props.saveButtonRequired == true )
		{
			this.state.saveButtonRequired = true ;
			this.state.saveButtonState = '';
		}
		else
		{
			this.state.saveButtonRequired = false ;
		}

		if ( this.props.nextButtonRequired == true )
		{
			this.state.nextButtonRequired = true ;
		}
		else
		{
			this.state.nextButtonRequired = false ;
		}

		if ( this.props.cancelButtonRequired == true )
		{
			this.state.cancelButtonRequired = true ;
		}
		else
		{
			this.state.cancelButtonRequired = false ;
		}

		this.onDirty = this.onDirty.bind(this) ;
		this.disableSaveButton = this.disableSaveButton.bind(this) ;
		this.enableSaveButton = this.enableSaveButton.bind(this) ;
	}

	disableSaveButton()
	{
		this.setState ( { saveButtonState: 'disabled'}) ;
	}

	enableSaveButton()
	{
		this.setState ( { saveButtonState: ''}) ;
	}

    onDirty()
    {
        if ( this.props.onDirty != null )
		{
			// Propagate a form dirty message
			this.props.onDirty();
		}
    }

	UNSAFE_componentWillReceiveProps( newProps )
	{
		if ( newProps.displayErrors != this.state.displayErrors )
		{
			this.setState ( { displayErrors : newProps.displayErrors }) ; 
		}
	}

	formIsValid ()
	{
       	var i = 0 ;
        
        // Iterate through all the child controls to test each is reporting itself valid
        for (var key in this.refs) 
        {
        	var obj = this.refs[key] ;
        	
			if ( typeof obj.isValid === 'function' )
			{
			  if ( !obj.isValid())
			  {
				  return false ;
			  }    	      
			}    	      
    	}
        
		return true ;
	}
	
	onNext() 
	{
		if ( !this.formIsValid())
		{
			this.setState ( { displayErrors : true })
		}
		else
		{
			this.doNextButton() ;
		}
	}

	onCancel()
	{
		// Should be implemented in inherited class
	}

	onPrevious() 
	{
		if ( !this.formIsValid())
		{
			this.setState ( { displayErrors : true })
		}
		else
		{
			this.doPrevButton() ;
		}
	}

	doNextButton()
	{
		if ( this.props.navigationNotifier != null )
		{
			this.props.navigationNotifier ( 'next' ) ;
		}
	}

	doPrevButton()
	{
		if ( this.props.navigationNotifier != null )
		{
			this.props.navigationNotifier ( 'prev' ) ;
		}
	}
	
	hyperlink ( tag, text )
	{
		return React.createElement ( 'a', { href: tag }, text ) ;
	}

	getNextButtonClickHandler(params)
	{
		// This returns a handler for the next button, which may be passed by the calling class if
		// we need to override the next button

		let nextHandler = null ;

		if ( params == null || params.onNext == null  )
		{
			nextHandler = this.onNext.bind(this) ;
		}
		else
		{
			if ( params.onNext != null )
			{
				nextHandler = params.onNext ;
			}
			else
			{
				nextHandler = this.onNext.bind(this) ;
			}
		}

		return nextHandler ;
	}

	getCancelButtonClickHandler(params)
	{
		// This returns a handler for the next button, which may be passed by the calling class if
		// we need to override the next button

		let nextHandler = null ;

		if ( params == null || params.onNext == null  )
		{
			nextHandler = this.onCancel.bind(this) ;
		}
		else
		{
			if ( params.onCancel != null )
			{
				nextHandler = params.onCancel ;
			}
			else
			{
				nextHandler = this.onCancel.bind(this) ;
			}
		}

		return nextHandler ;
	}

	colNextButton(cols, params)
	{
		return (
			<div key='colNextButtonDiv' className={'col-md-' + cols}>
				<ul key='colNextButtonDivUL' className='pager'>
					<li key='colNextButtonDivLI' className='next formnext'>
						<a href='#' onClick={this.getNextButtonClickHandler(params)}>Next</a>
					</li>
					{ this.state.cancelButtonRequired === true && <li key='colCancelButtonDivLI' className='next formcancel'>
						<a href='#' onClick={this.getCancelButtonClickHandler(params)} style={{ marginRight: '10px' }}>Cancel</a>
					</li> }
				</ul>
			</div>
		) ;
	}

	colSaveButton(cols, params)
	{
		if ( this.state.saveButtonState === 'disabled')
		{
			return (
				<div key='colSaveButtonDiv' className={'col-md-' + cols}>
					<ul key='colSaveButtonDivUL' className='pager'>
						<li key='colSaveButtonDivLI' className='next formnext'>
							<a href='#'  style={{ color: 'white', backgroundColor: 'rgb(141,141,141)', cursor: 'wait' }}>Save</a>
						</li>
					</ul>
				</div>
			) ;
		}
		else
		{
			return (
				<div key='colSaveButtonDiv' className={'col-md-' + cols}>
					<ul key='colSaveButtonDivUL' className='pager'>
						<li key='colSaveButtonDivLI' className='next formnext'>
							<a href='#' onClick={this.getNextButtonClickHandler(params)} style={{ color: 'white', backgroundColor: 'rgb(14,180,141)'}}>Save</a>
						</li>
					</ul>
				</div>
			) ;
		}
	}

	colPrevButton ( cols, params )
	{
		return (
			<div key='colPrevButtonDiv' className={'col-md-' + cols}>
				<ul key='colPrevButtonDivUL' className='pager'>
					<li key='colPrevButtonDivLI' className='previous'>
						<a href='#' onClick={this.onPrevious.bind(this)}>Previous</a>
					</li>
				</ul>
			</div>
		) ;
	}

	colNoButtons ( cols, keyVal )
	{
		return <div key={'colNoButtonDiv'+keyVal} className={'col-md-' + cols} />
	}

	buttonCount ()
	{
		let count =  0 ;

		if ( this.state.prevButtonRequired )
		{
			count++ ;
		}

		if ( this.state.nextButtonRequired || this.state.saveButtonRequired )
		{
			count++ ;
		}

		return count ;
	}

	buttonRowMultiPage( params )
	{
		let lineList = [] ;

		if ( this.state.prevButtonRequired )
		{
			lineList.push ( this.colPrevButton(6, params)) ;
		}
		else
		{
			lineList.push ( this.colNoButtons(6, 'colNoButtonPrev')) ;
		}

		if ( this.state.nextButtonRequired )
		{
			lineList.push(this.colNextButton ( 6, params )) ;
		}
		else if ( this.state.saveButtonRequired )
		{
			lineList.push(this.colSaveButton ( 6, params )) ;
		}
		else
		{
			lineList.push ( this.colNoButtons(6, 'colNoButtonSave')) ;
		}

		return lineList ;
	}

	navFormRow( params )
	{
		return <div key={'navFormRowDiv'} className='row panel-body'>
					{ this.buttonRowMultiPage( params ) }
		       </div>
	}

	transformDataToFormDefinition ( definitions )
	{
		let items = [] ;

		for (let key in definitions )
		{
			let cur = definitions[key] ;

			let obj = {} ;

			obj.ref = cur.ref ;
			obj.label = cur.prompt ;
			obj.field_type = cur.field_type ;
			obj.data_type = cur.data_type ;
			obj.validation = {} ;
			obj.colSpan = cur.colspan ;
			obj.record_id = cur.form_instance_data_id ;

			obj.value = this.getValueForDataType ( cur ) ;

			obj.item_name = cur.data_item_name ;
			obj.default = null ;

			items.push ( obj) ;
		}

		return items ;
	}

	getValueForDataType ( formDefinition )
	{
		let val = null ;

		switch ( formDefinition.field_type )
		{
			case 'input':
				if ( formDefinition.data_type == 'int')
				{
					val = formDefinition.form_data_value_int ;
				}
				else
				{
					val = formDefinition.form_data_value_text ;
				}
				break ;
			case 'textarea':
				val = formDefinition.form_data_value_text ;
				break ;
			case 'dropdown_year':
				val = formDefinition.form_data_value_int ;
				break ;
			case 'dropdown_yesno':
				val = formDefinition.form_data_value_text ;
				break ;
			case 'dropdown_yesno_unknown':
				val = formDefinition.form_data_value_text ;
				break ;
			case 'dropdown_attitude':
				val = formDefinition.form_data_value_int ;
				break ;
			case 'dropdown_met_notmet':
				val = formDefinition.form_data_value_text ;
				break ;
			case 'date':
				val = formDefinition.form_data_value_date ;
				break ;
			default:
				val = formDefinition.form_data_value_text ;
				break ;
		}

		return val ;
	}

	getReadOnlyText()
	{
		let readonly = '' ;

		if ( this.props.readonly == true || this.state.mode == 'view')
		{
			readonly = "readonly";
		}

		return readonly ;
	}

	createInputElement ( definition )
	{
		let className = 'col-md-' + definition.colSpan ;

		return React.createElement ( 'div', { className: className, key: 'col' + definition.ref + definition.record_id } ,
			React.createElement ( UserInput, {
				validation:  definition.validation,
				id: definition.ref,
				ref: definition.ref,
				value: definition.value,
				name: definition.ref,
				labelText: definition.label,
				readOnly: this.getReadOnlyText(),
				displayErrors:this.state.displayErrors,
				key: definition.ref + definition.record_id
			})) ;
	}

	createDateInputElement ( definition )
	{
		let className = 'col-md-' + definition.colSpan ;

		let validation = definition.validation ;
		validation.isDate = true ;
		validation.maxlen = 10 ;

		return React.createElement ( 'div', { className: className, key: 'col' + definition.ref + definition.record_id } ,
			React.createElement ( UserInput, {
				validation:  validation,
				id: definition.ref,
				ref: definition.ref,
				value: definition.value,
				name: definition.ref,
				labelText: definition.label,
				readOnly: this.getReadOnlyText(),
				displayErrors:this.state.displayErrors,
				key: definition.ref + definition.record_id
			})) ;
	}

	createTextAreaElement ( definition )
	{
		let className = 'col-md-' + definition.colSpan ;

		return React.createElement ( 'div', { className: className, key: 'col' + definition.ref + definition.record_id } ,
			React.createElement ( UserInputTextarea, {
				validation:  definition.validation,
				id: definition.ref,
				ref: definition.ref,
				value: definition.value,
				name: definition.ref,
				label: definition.label,
				rows: definition.rows,
				readOnly: this.getReadOnlyText(),
				displayErrors:this.state.displayErrors,
				key: definition.ref + definition.record_id
			})) ;
	}

	createDropdownYearElement ( definition )
	{
		let className = 'col-md-' + definition.colSpan ;

		return React.createElement ( 'div', { className: className, key: 'col' + definition.ref + definition.record_id } ,
			React.createElement ( DropdownSchoolYear, {
				ref: definition.ref,
				validation:  definition.validation,
				displayErrors: this.props.displayErrors,
				readOnly: this.getReadOnlyText(),
				errorText: 'You must select a value',
				label: definition.label,
				key: definition.ref + definition.record_id,
				defaultValue: definition.value} )) ;
	}

	createDropdownYesNoElement ( definition )
	{
		let className = 'col-md-' + definition.colSpan ;

		return React.createElement ( 'div', { className: className, key: 'col' + definition.ref + definition.record_id } ,
			React.createElement ( DropdownYesNo, {
				ref: definition.ref,
				validation:  definition.validation,
				label: definition.label,
				key: definition.ref + definition.record_id,
				errorText: 'Valid progress required',
				defaultValue: definition.value,
				readOnly: this.getReadOnlyText(),
//				containerClassName: 'input-group',
				displayErrors:this.state.displayErrors
			}));
	}

	createDropdownYesNoUnknownElement ( definition )
	{
		let className = 'col-md-' + definition.colSpan ;

		return React.createElement ( 'div', { className: className, key: 'col' + definition.ref + definition.record_id } ,
			React.createElement ( DropdownYesNoUnknown, {
				ref: definition.ref,
				validation:  definition.validation,
				label: definition.label,
				key: definition.ref + definition.record_id,
				errorText: 'Valid progress required',
				defaultValue: definition.value,
				readOnly: this.getReadOnlyText(),
//				containerClassName: 'input-group',
				displayErrors:this.state.displayErrors
			}));
	}

	createDropdownMetNotMetElement ( definition )
	{
		let className = 'col-md-' + definition.colSpan ;

		return React.createElement ( 'div', { className: className, key: 'col' + definition.ref + definition.record_id } ,
			React.createElement ( DropdownMetNotMet, {
				ref: definition.ref,
				validation:  definition.validation,
				label: definition.label,
				key: definition.ref + definition.record_id,
				errorText: 'Valid attainment required',
				defaultValue: definition.value,
				readOnly: this.getReadOnlyText(),
//				containerClassName: 'input-group',
				displayErrors:this.state.displayErrors
			}));
	}

	createDropdownAttitudeElement ( definition )
	{
		let className = 'col-md-' + definition.colSpan ;

		return React.createElement ( 'div', { className: className, key: 'col' + definition.ref + definition.record_id } ,
			React.createElement(DropdownAttitude, {
				ref: definition.ref,
				validation:  definition.validation,
				label: definition.label,
				key: definition.ref + definition.record_id,
				defaultValue: definition.value,
				errorText: 'Valid selection required',
				readOnly: this.getReadOnlyText(),
				displayErrors: this.state.displayErrors,
			}));
	}

	renderItem ( formDefinition )
	{
		const fieldType = formDefinition['field_type'] ;

		switch ( fieldType )
		{
			case 'input' :
				return this.createInputElement(formDefinition);
				break ;
			case 'date' :
				return this.createDateInputElement(formDefinition);
				break ;
			case 'textarea' :
				return this.createTextAreaElement(formDefinition);
				break ;
			case 'dropdown_year' :
				return this.createDropdownYearElement(formDefinition);
				break ;
			case 'dropdown_yesno' :
				return this.createDropdownYesNoElement(formDefinition);
				break ;

			case 'dropdown_yesno_unknown' :
				return this.createDropdownYesNoUnknownElement(formDefinition);
				break ;

			case 'dropdown_met_notmet' :
				return this.createDropdownMetNotMetElement(formDefinition);
				break ;
			case 'dropdown_attitude' :
				return this.createDropdownAttitudeElement(formDefinition);
				break ;
			default:
				throw Error('Invalid field Type ' + fieldType );
		}
	}

	getFormComponents()
	{
		let lineList = [] ;

		let cols = [] ;
		let rows = 0 ;

		let thisRowCols = 0 ;

		const formDefinition = this.getFormDefinition();

		for (let i in formDefinition)
		{
			cols.push( this.renderItem(formDefinition[i])) ;

			thisRowCols += +formDefinition[i]['colSpan'] ;

			if ( thisRowCols >= 12 )
			{
				lineList.push ( React.createElement ( 'div', { className: 'row', key: 'DynamicFormRow' + rows }, cols ));
				thisRowCols = 0 ;
				rows++ ;
				cols = [] ;
			}
		}

		if ( thisRowCols != 0 )
		{
			// If the row isn't complete, pad with an empty cell
			let className = 'col-md-' + ( 12 - thisRowCols );

			cols.push ( React.createElement ( 'div', { className: className } )) ,

				lineList.push ( React.createElement ( 'div', { className: 'row', key: 'DynamicRow1' + rows }, cols ));
		}

		return lineList ;
	}

};
